import { get, put} from '../../../api/commonAPI';
import {space} from '../../../api/apiPaths'
import {clearSpaceDetails} from '../Spaces/SpaceAction'
import toastr from 'toastr';
import {UPDATE_SPACEOWNER_DETAILS,
        UPDATE_SPACEOWNER_DETAILS_SUCCESS,
        UPDATE_SPACEOWNER_DETAILS_FAILS,
        FETCH_FILTERSPACENAME,
        FETCH_FILTERSPACENAME_SUCCESS,
        FETCH_FILTERSPACENAME_FAILS,
        FETCH_SPACEDETAILS,
        FETCH_SPACEDETAILS_SUCCESS,
        FETCH_SPACEDETAILS_FAILS
} from './AssignSpaceActionType'

export const updateSpaceOwnerDetails =  (values, version, clearFields) => {
    return  dispatch => {
      dispatch({
        type: UPDATE_SPACEOWNER_DETAILS
      });
      const versionHeader = {'If-Match': version};
      let url = `${space}/${values.id}/space-owner`;
        put(url, values, versionHeader)
        .then(res => {
          dispatch({
            type:UPDATE_SPACEOWNER_DETAILS_SUCCESS,
            payload:res.data,
          })
          dispatch(clearSpaceDetails())
          clearFields();
          toastr.success('Successfully saved')
        })
        .catch(error => {
          dispatch({
            type: UPDATE_SPACEOWNER_DETAILS_FAILS,
            payload:error,
          })
          toastr.error("Failed to save")
        });
    };
};
  
export const filterSpaceName = (page, size, spacename, country) => {
    return dispatch => {
      dispatch({
        type: FETCH_FILTERSPACENAME
      });
      let url = `${space}/filter?page=${page}&size=${size}&q=${spacename}&country=${country}`
      get(url)
        .then(res => {
          dispatch({
            type: FETCH_FILTERSPACENAME_SUCCESS,
            payload: res.data
          });
        })
        .catch(error => {
          dispatch({
            type: FETCH_FILTERSPACENAME_FAILS,
            payload: error
          });
        });
    };
}

export const fetchSpaceDetails =  (id, category, setFetchedData) => {
    return  dispatch => {
      dispatch({
        type: FETCH_SPACEDETAILS
      });
        let url;
        if(category === 'Train')
          url = `${space}/train/${id}`;
        else if(category === 'Meet')
          url = `${space}/meet/${id}`;
        else
          url = `${space}/${id}`;
        get(url)
        .then(res => {
          dispatch({
            type: FETCH_SPACEDETAILS_SUCCESS,
            payload: res.data
          });
          setFetchedData(true)
        })
        .catch(error => {
          dispatch({
            type: FETCH_SPACEDETAILS_FAILS,
            payload: error
          });
        });
    };
};